import { mixed } from "yup";
import { DiffServ, IntServ, Qos } from "./types";
import { Enum_MtuMode, Enum_MtuSize, Enum_TosType } from "generated/graphql";
import { boolean, mixedEnum, number, object } from "./helpers";

const oam = number("OAM");
const audio = number("AUDIO");
const video = number("VIDEO");
const fecc = number("CONTROL");
const diffServ = object<DiffServ>({
  audio,
  video,
  fecc,
  oam
});
const intServ = object<IntServ>({
  audio,
  video,
  fecc,
  oam
});

export const qos = object<Qos>({
  diffServ,
  intServ,
  tosType: mixedEnum(Enum_TosType, "TYPE_OF_SERVICE").default(
    Enum_TosType.DiffServ
  ),
  mtuMode: mixedEnum(Enum_MtuMode, "Not used again lol").default(
    Enum_MtuMode.Default
  ),
  mtuSize: mixed()
    .label("MTU_SIZE_BYTES")
    .when("mtuMode", {
      is: Enum_MtuMode.Specify,
      then: mixed().oneOf(Object.values(Enum_MtuSize))
    })
    .default(Enum_MtuSize.Six60),
  LPR: object({
    enable: boolean("LOST_PACKET_RECOVERY")
  }),
  rsvp: object({
    enable: boolean("ENABLE_RSVP")
  }),
  dynamicBandwidth: object({
    enable: boolean("DYNAMIC_BANDWIDTH")
  })
});
